export const Bio = {
  name: "Aqueel ur rahman Khan",
  roles: [
    "Network Security Engineer",
    "Open-Source contributor",
    "AI Enthusiast",
    "Technical Blogger",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/Rahmaaaan",
  resume:
    "https://drive.google.com/file/d/1ohHpDjFzDfOYKPo07H8UKhNCeA0QfjdF/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/therahman/",
  twitter: "https://twitter.com/therahmaan",
  medium: "https://medium.com/@therahman14",
  whatsapp: "https://wa.me/qr/MBHIRWDZITCYO1",
  leetcode: "https://leetcode.com/therahman/",
  gfg: "https://auth.geeksforgeeks.org/user/therahman",
  linktree: "https://linktr.ee/rahmancodes",
};

export const skills = [
  {
    title: "Frontend Developement",
    skills: [
      {
        name: "HTML",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779455/HTML_ougmeu.png",
      },
      {
        name: "CSS",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779508/CSS_jtx7pj.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779454/Bootstrap_cqo8bl.png",
      },
      {
        name: "Material UI",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779459/MaterialUI_jz086l.png",
      },
      {
        name: "Tailwind",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779461/TailwindCSS_cj71qd.png",
      },
      {
        name: "JavaScript",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779506/Javascript_xqsmch.png",
      },
      {
        name: "TypeScript",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779464/Typescript_dyoar3.png",
      },
      {
        name: "jQuery",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779466/jQuery_qp4m8p.png",
      },
      {
        name: "React Js",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779506/ReactJS_z4jzve.png",
      },
      {
        name: "Redux",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779501/Redux_j44mrq.png",
      },
      {
        name: "Next Js",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779471/NextJS_q5qu6f.png",
      },
    ],
  },
  {
    title: "Backend Development",
    skills: [
      {
        name: "Node Js",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779472/NodeJS_dskx0h.png",
      },
      {
        name: "Express Js",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779477/ExpressJS_vgzboy.png",
      },
      {
        name: "Embedded Js",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779478/EJS_k2koay.png",
      },
      {
        name: "Django",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779486/Django_muogfv.png",
      },
      {
        name: "Postgresql",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779487/PostgresSQL_ueho7e.png",
      },
      {
        name: "MongoDB",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779491/MongoDB_tmcn1j.png",
      },
      {
        name: "Graph Ql",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779448/GraphQL_fro4vu.png",
      },
      {
        name: "Supabase",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779499/Supabase_yedoqt.png",
      },
      {
        name: "Firebase",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779496/Firebase_sizt1h.png",
      },
    ],
  },
  {
    title: "Data Analysis and Virtualization",
    skills: [
      {
        name: "Python",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779493/Python_d7ihqn.png",
      },
      {
        name: "Pandas",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779451/Pandas_luvic2.png",
      },
      {
        name: "NumPy",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779446/Numpy_nfmoaf.png",
      },
      {
        name: "Matplotlib",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779442/Matplotlib_cte8ut.png",
      },
      {
        name: "Seaborn",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779433/Seaborn_hnruar.png",
      },
      {
        name: "Scikit-Learn",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779438/Scikit-learn_xw7iba.png",
      },
      {
        name: "TensorFlow",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779441/Tensorflow_i0dugh.png",
      },
      {
        name: "Keras",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779436/Keras_omzlpn.png",
      },
    ],
  },
  {
    title: "Concepts",
    skills: [
      {
        name: "Object oriented programming",
      },
      {
        name: "Data structure & Algorithm",
      },
      {
        name: "Database management system",
      },
      {
        name: "Software Engineering",
      },
      {
        name: "Computer architecture",
      },
      {
        name: "Cryptography & Cyber security",
      },
    ],
  },
  {
    title: "Version Control & Deployment",
    skills: [
      {
        name: "Git",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779430/Git_jl1xpi.png",
      },
      {
        name: "GitHub",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779428/Github_kmycfu.png",
      },
      {
        name: "Docker",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779425/docker_zue36g.png",
      },
      {
        name: "Vercel",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779427/vercel_apwasj.png",
      },
      {
        name: "Netlify",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779424/netlify_xani4x.png",
      },
    ],
  },
  {
    title: "Tools",
    skills: [
      {
        name: "VS Code",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779422/vs_code_klwis1.png",
      },
      {
        name: "PyCharm",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779421/pycharm_avihvq.png",
      },
      {
        name: "Jupyter Notebook",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779419/jupyter_js6iqm.png",
      },
      {
        name: "Postman",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779417/postman_loygah.png",
      },
      {
        name: "Canva",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779415/canva_gfyfcd.png",
      },
      {
        name: "Putty",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773784451/Putty_ygkbnq.png",
      },
      {
        name: "Salesforce",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773784752/Salesforce_u8nxf5.svg",
      },
      {
        name: "Grafana",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773784751/Grafana_nhhzxi.webp",
      },
      {
        name: "Wireshark",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773782076/Wireshark_rkrcxo.png",
      },
      {
        name: "Citrix",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773784436/Citrix_clm0tu.webp",
      },
    ],
  },

  {
    title: "Networking Routing & Switching",
    skills: [
      { name: "IP Addressing & Subnetting" },
      { name: "BGP" },
      { name: "OSPF" },
      { name: "EIGRP" },
      { name: "GRE Tunnels" },
      { name: "L3VPN" },
      { name: "NAT" },
      { name: "DNS & DHCP" },
      { name: "MTU / QoS" },
      { name: "VLAN & STP" },
      { name: "Cisco IOS / ASR CLI" },
      { name: "Juniper CLI" },
      { name: "Nokia CLI" },
    ],
  },

  {
    title: "SD-WAN & Security",
    skills: [
      { name: "SD-WAN" },
      { name: "Overlay Tunnels & Failover" },
      { name: "Edge Configurations" },
      { name: "VeloCloud" },
      { name: "Fortinet" },
      { name: "Meraki" },
      { name: "Firewall Policy Management" },
      { name: "Site-to-Site VPN" },
      { name: "Azure VPN / AWS VPC" },
    ],
  },
  {
    title: "Networking Hardware Configuration",
    skills: [
      {
        name: "Cisco",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773786383/CISCO_khnzhl.png",
      },
      {
        name: "Juniper",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773786902/Juniper_dygikb.png",
      },
      {
        name: "Nokia",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773786998/Nokia_cqlymz.png",
      },
      {
        name: "Adtran",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773787111/Adtran_dijkrf.png",
      },
      {
        name: "Calix",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773786374/Calix_cv5ea8.png",
      },
      {
        name: "Grandstream ATA",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773793141/Grandstream_w2zhpj.jpg",
      },
      {
        name: "Sagemcom ATA",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773793540/sagemcom_osgbyk.png",
      },
      { name: "ALGO Paging", image: "" },
      { name: "EnGenius", image: "" },
      {
        name: "Mitel",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773793755/Mitel_vexy9u.png",
      },
      {
        name: "Polycom",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773793756/Polycom_poka3u.png",
      },
      { name: "RTX Cordless", image: "" },
      { name: "TK920", image: "" },
      {
        name: "Yealink",
        image:
          "https://res.cloudinary.com/dpb7crcko/image/upload/v1773787110/Yealink_mkyquv.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 2,
    img: "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779025/HGS_rdwb1w.jpg",
    role: "Network Analyst – Level 2",
    company: "Hinduja Global Solutions (Client: Windstream, USA)",
    date: "Jan 2024 – May 2025",
    desc: "Served as the primary L2 escalation contact for L1 engineers and field technicians, resolving 5,000+ complex incidents across Data, VoIP, SD-WAN, OfficeSuite, and wireless infrastructure while consistently meeting SLA thresholds. Performed advanced CLI-based diagnostics on Cisco IOS/ASR routers and switches; managed firewall policies and network configurations on Fortinet and Meraki platforms to maintain uptime and security posture. Diagnosed and resolved critical IP routing failures involving BGP, OSPF, L3VPN, and GRE tunnels; executed structured Root Cause Analysis (RCA) using Grafana, PuTTY, VeloCloud, and Sil Snapshot to eliminate recurring failure patterns. Troubleshot SD-WAN overlay tunnels, wireless modem outages, and VoIP call failures including SIP registration errors, RTP codec misconfigurations, and trunk failures across Mitel, Polycom, Adtran, Calix, Grandstream, and Sagemcom ATA. Supported enterprise UCaaS integrations (Officesuite Teams UC, softphones, CCS) and administered backend provisioning via MetaView, Silhouette, and OS Portal. Handled complete incident lifecycle in Salesforce Service Cloud; proactively analysed recurring ticket patterns and initiated Problem Management activities to drive long-term infrastructure fixes. Coordinated with L3 teams and vendors/carriers for high-severity incidents and participated in change implementation. Authored SOPs for SD-WAN and VoIP incident handling, measurably reducing MTTR; mentored L1 engineers on escalation procedures, technical diagnostics, and process adherence. Leveraged cloud networking exposure (Azure/AWS VPC, site-to-site VPN) to support hybrid enterprise environments.",
    skills: [
      // Routing & Switching
      "Cisco IOS/ASR CLI",
      "Switches",
      "BGP",
      "OSPF",
      "EIGRP",
      "L3VPN",
      "GRE Tunnels",
      "IP Routing",
      "VLAN",
      "STP",

      // SD-WAN & Firewall
      "SD-WAN",
      "VeloCloud",
      "Fortinet",
      "Firewall Policy Management",
      "Meraki",
      "Access Point",

      // VoIP & UCaaS
      "VoIP",
      "MetaView",
      "SIP",
      "RTP",
      "Mitel",
      "Polycom",
      "Grandstream ATA",
      "Sagemcom ATA",
      "Adtran",
      "Calix",
      "Microsoft Teams UCaaS",
      "Softphones",
      "CCS",
      "ALGO Paging",
      "EnGenius",
      "RTX Cordless",
      "TK920",
      "Yealink",

      // Monitoring & Diagnostics
      "Grafana",
      "PuTTY",
      "RCA",
      "Salesforce Service Cloud",
      "Silhouette",
      "OS Portal",

      // Cloud & Hybrid
      "Azure VPC",
      "AWS VPC",
      "Site-to-Site VPN",

      // Leadership
      "L1 Mentoring",
      "Escalation Management",
    ],
    doc: "https://drive.google.com/file/d/19BsRPtMD5nt0IJetRCvuhqlc-4F2AVfi/view?usp=drive_link",
  },
  {
    id: 1,
    img: "https://res.cloudinary.com/dpb7crcko/image/upload/v1773778878/UG_council_wea1en.jpg",
    role: "President",
    company: "Undergraduate Student Council",
    date: "June 2022 - September 2023",
    desc: "Accomplished a 41% enhancement in academic policies by improving student satisfaction and performance through the leadership of 85 class representatives and close collaboration with college management, implementing innovative strategies.",
    skills: ["Canva", "Team Management", "Leadership", "Event management"],
    // doc: "",
  },
  {
    id: 0,
    img: "https://res.cloudinary.com/dpb7crcko/image/upload/v1773778879/ORCA_iiet9z.jpg",
    role: "Co-founder & Secretary",
    company: "The Oxford Research Club Associates (ORCAs)",
    date: "Jan 2021 - September 2023",
    desc: "Elevated the exploration and learning of new concepts, languages, and technologies among 160+ members, resulting in a 30% increase in proficiency as measured by surveys and assessments through innovative workshops, seminars, and hands-on projects.",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
      "Boootstrap",
      "jQuery",
      "Node.js",
      "SDC",
    ],
    doc: "",
  },
];

export const education = [
  {
    id: 0,
    img: "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779058/VTU_zanzda.png",
    school: "Visvesvaraya Technological University (VTU)",
    date: "Dec 2023 - Oct 2025",
    grade: "8.1 CGPA",
    desc: "I hold a Master's degree in Computer Applications from The Oxford College of Engineering, affiliated with Visvesvaraya Technological University (VTU), graduating with a commendable CGPA of 8.1. My academic journey covered essential areas in computer science, including Data Science, Cloud Computing, Blockchain, Deep Learning, and Big Data Analysis, which have equipped me with a strong technical foundation and analytical mindset",
    degree: "Master's in Computer Applications - MCA",
  },
  {
    id: 1,
    img: "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779055/Sri_gayatri_zedtv5.png",
    school: "Bangalore University",
    university: "The Oxford college of Science, Bangalore",
    date: "Aug 2020 - Sep 2023",
    grade: "8.2 CGPA",
    desc: "I earned my Bachelor's degree in Computer Applications from The Oxford College of Science, affiliated with Bangalore University, with a notable CGPA of 8.2. My coursework encompassed key subjects such as Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, providing a solid foundation in core computer science concepts.",
    degree: "Bachelor's in Computer Applications - BCA",
  },
  {
    id: 2,
    img: "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779055/BU_cbb5k3.jpg",
    school: "Sri Gayatri junior College",
    date: "Jun 2017 - Mar 2019",
    grade: "86%",
    desc: "I successfully finished my class 12 education at Sri Gayatri Junior College in Hyderabad, specializing in Science with a focus on Biology, Physics, and Chemistry.",
    degree: "TSBIE (XII), Science",
  },
  {
    id: 3,
    img: "",
    school: "Stamford Grammar High School",
    date: " - Mar 2017",
    grade: "85%",
    desc: "I successfully completed my secondary education at Stamford Grammar High School in Hyderabad, culminating with the attainment of my Class 10 certification.",
    degree: "BSET (X)",
  },
];

export const projects = [
  {
    id: 11,
    title: "DocX",
    date: "Dec 2023 - Jan 2024",
    description:
      "DocX is an innovative document management platform designed to revolutionize the way teams collaborate and manage their documents. It offers a comprehensive workspace and collaboration environment tailored for seamless teamwork and efficient document handling.",
    image:
      "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779412/DocX_n7ufzt.jpg",
    tags: [
      "TailwindCSS",
      "TypeScript",
      "React",
      "Next.js",
      "Supabase",
      "Stripe",
    ],
    category: "web",
    github: "https://github.com/Rahmaaaan/DocX",
    webapp: "https://docs-x.vercel.app/",
  },
  {
    id: 0,
    title: "Sportify",
    date: "Dec 2023 - Jan 2024",
    description:
      "Sportify one-stop-shop for all your fitness needs! Our e-commerce platform specializes in providing top-quality sport and gym equipment, stylish sportswear, trendy accessories, and authentic team jerseys for all sports enthusiasts and fitness aficionados.",
    image:
      "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779413/Sportify_xfjnri.png",
    tags: [
      "SCSS",
      "JavaScript",
      "Typescript",
      "Next.js",
      "Node.js",
      "Express Js",
      "MongoDB",
      "Stripe",
    ],
    category: "web",
    github: "https://github.com/Rahmaaaan/Sportify",
    webapp: "",
    member: [
      {
        name: "Aqueel ur Rahman Khan",
        img: "https://res.cloudinary.com/dpb7crcko/image/upload/v1773775685/HeroImage_jiskk6.png",
        linkedin: "https://www.linkedin.com/in/therahman/",
        github: "https://github.com/Rahmaaaan",
      },
      {
        name: "Mohammed Adnan",
        img: "",
        linkedin: "",
        github: "",
      },
      {
        name: "Mohammed Taufiq Hussain",
        img: "",
        linkedin: "",
        github: "",
      },
    ],
  },
  {
    id: 10,
    title: "Taskflow",
    date: "Dec 2023",
    description:
      "Taskflow is a versatile productivity app that integrates various functionalities within a unified platform, catering to individual, team, and business workflows. With an array of features, it offers a seamless experience for creating documents, wikis, project boards, notes, and more.",
    image:
      "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779410/Taskflow_mysphs.jpg",
    tags: [
      "TailwindCSS",
      "TypeScript",
      "React",
      "Next.js",
      "Clerk",
      "Edge store",
      "Convex",
    ],
    category: "web",
    github: "https://github.com/Rahmaaaan/Taskflow",
    webapp: "https://taaskflow.vercel.app/",
  },
  {
    id: 15,
    title: "IMDB Movie Data Analysis",
    date: "May 2024",
    description:
      "A comprehensive data analysis project exploring relationships between movie budgets, popularity, runtime, genres, and profitability using the IMDB dataset. This study utilizes Python's data analysis stack to derive insights into film industry trends.",
    image:
      "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779409/DAP_e0i6o8.png",
    tags: [
      "Python",
      "Pandas",
      "NumPy",
      "Matplotlib",
      "Seaborn",
      "Jupyter Notebook",
    ],
    category: "DA",
    github: "https://github.com/Rahmaaaan/DataAnalysisUsingIMDBMovie",
    webapp:
      "https://github.com/Rahmaaaan/DataAnalysisUsingIMDBMovie/blob/main/Data%20analysis%20using%20IMDB%20Movie.ipynb",
  },
  {
    id: 9,
    title: "SummarizeAI",
    date: "Nov 2023 - Dec 2023",
    description:
      "SummarizeAI is an AI-integrated web application designed to summarize articles effortlessly. By simply entering an article link, the application utilizes advanced AI algorithms to condense the content, providing users with concise and efficient summaries. Powered by RapidApi's Article Extractor and Summarizer, this tool streamlines the process of extracting key information from lengthy articles, making it an ideal solution for users seeking quick insights without delving into full-length content.",
    image:
      "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779408/SummarizeAI_jekq2i.png",
    tags: [
      "Tailwind CSS",
      "React Js",
      "Redux",
      "RapidApi (Article Extractor and Summarizer)",
    ],
    category: "DA",
    github: "https://github.com/Rahmaaaan/SummarizeAI",
    webapp: "https://summarize-article-ai.vercel.app/",
  },
  {
    id: 12,
    title: "Expense Tracker",
    date: "Jan 2024",
    description:
      "Expense Tracker is a web application designed to help users manage and track their expenses efficiently. It provides a user-friendly interface to input, categorize, and monitor spending across various categories in order to facilitate better financial management.",
    image:
      "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779405/Expense_Tracker_rb3a68.png",
    tags: ["Tailwind CSS", "JavaScript", "React", "Redux"],
    category: "web",
    github: "https://github.com/Rahmaaaan/ExpenseTracker",
    webapp: "https://checkyourexpenses.vercel.app/",
  },
  {
    id: 13,
    title: "Weather App",
    date: "Jan 2024",
    description:
      "Weather App provides users with up-to-date weather information for any location. With a clean and intuitive interface, users can easily check current weather conditions.",
    image:
      "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779401/Weather_App_yhnfge.png",
    tags: ["Tailwind CSS", "JavaScript", "React", "Weather API"],
    category: "web",
    github: "https://github.com/Rahmaaaan/WeatherApp",
    webapp: "https://letscheckweather.vercel.app/",
  },
  {
    id: 7,
    title: "GameHub",
    date: "Sept 2023 - Oct 2023",
    description:
      "Game Hub is a comprehensive web application built using React and TypeScript, designed to provide gamers with an engaging platform to explore and discover various video games. This project incorporates essential aspects of modern web applications, including responsiveness, accessibility, and efficient state management. It consumes data from the RAWG API, one of the largest video game databases, to provide detailed information about games, including titles, thumbnails, screenshots, videos, and more.",
    image:
      "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779407/Game_hub_bdmkgc.png",
    tags: ["Chakra UI", "React Js", "TypeScript", "RAWG API"],
    category: "web",
    github: "https://github.com/Rahmaaaan/GameHub",
    webapp: "https://gaamehub.vercel.app/",
  },
  {
    id: 4,
    title: "To do list",
    date: "Jul 2023",
    description:
      "To-Do List is a web application designed for managing your tasks. You can easily add new tasks, mark them as completed, and remove tasks from your list. This app utilizes MongoDB and ExpressJS to make task management a breeze. It also offers the convenience of creating separate lists for various interests using Express routing.",
    image:
      "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779403/To_Do_list_ftajvh.jpg",
    tags: [
      "HTML",
      "CSS",
      "JavaScript",
      "EJS",
      "Node Js",
      "Express Js",
      "MongoDB",
    ],
    category: "web",
    github: "https://github.com/Rahmaaaan/Todolist",
    webapp: "https://todolist-59t5.onrender.com/",
  },
  {
    id: 8,
    title: "Stickify",
    date: "Nov 2023",
    description:
      "Stickify: Your note-taking ally. Like Google Keep, it's effortless. Create, organize, and manage digital sticky notes hassle-free. User-friendly interface, intuitive features. Easily handle thoughts, tasks, and reminders neatly.",
    image:
      "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779399/Stickify_fa1o9x.jpg",
    tags: ["React Js", "Node Js", "Express Js", "MongoDB"],
    category: "web",
    github: "https://github.com/Rahmaaaan/Stickify",
    webapp: "",
  },
  {
    id: 6,
    title: "Flagpedia",
    date: "Aug 2023",
    description:
      "Flagpedia is a comprehensive resource providing essential information about flags from around the world. This repository serves as a valuable reference for accessing flag names, Unicode representations, and dial codes for all countries flags.",
    image:
      "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779395/Flagpedia_qsvptc.png",
    tags: ["JavaScript", "React"],
    category: "web",
    github: "https://github.com/Rahmaaaan/Flagpedia",
    webapp: "https://flagpedia.vercel.app/",
  },
  {
    id: 2,
    title: "World Capital Quiz",
    date: "Jun 2023",
    description:
      "Explore and test your global capital knowledge with the World Capital Quiz! This interactive platform challenges you to identify country capitals from around the world. See how well you know these capitals in this engaging quiz!",
    image:
      "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779394/World_capital_quiz_ykttl1.jpg",
    tags: [
      "HTML",
      "CSS",
      "JavaScript",
      "Node.js",
      "Express.js",
      "PostgreSQL",
      "EJS (Embedded JavaScript)",
    ],
    category: "web",
    github: "https://github.com/Rahmaaaan/WorldCapitalQuiz",
    webapp: "",
  },
  {
    id: 1,
    title: "BlogPost",
    date: "Apr 2023",
    description:
      "Blog post is a versatile web application that empowers you to create, publish, and manage your own blogs with ease. Whether you're a seasoned blogger or just getting started, our platform provides a user-friendly interface for crafting captivating articles and seamlessly organizing your content.",
    image:
      "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779392/Blog_mrxauj.png",
    tags: [
      "HTML",
      "CSS",
      "JavaScript",
      "Node.js",
      "Express.js",
      "EJS (Embedded JavaScript)",
    ],
    category: "web",
    github: "https://github.com/Rahmaaaan/BlogPost",
    webapp: "",
  },
  {
    id: 5,
    title: "Emojipedia",
    date: "Aug 2023",
    description:
      "Emojipedia is your go-to resource for emojis, providing a thorough compilation with each emoji accompanied by a detailed name and description. Whether you're a casual user seeking to grasp the significance of a particular emoji or a developer in need of precise information for seamless emoji integration, Emojipedia is your one-stop solution.",
    image:
      "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779392/Emojipedia_kw4acq.png",
    tags: ["JavaScript", "React"],
    category: "web",
    github: "https://github.com/Rahmaaaan/Emojipedia",
    webapp: "https://knowyouremoji.vercel.app/",
  },
  {
    id: 3,
    title: "Flags Quiz",
    date: "Jun 2023",
    description:
      "Test and enhance your knowledge about countries flags with the engaging Flags Quiz! This interactive platform challenges you to identify flags from around the world. See how well you know these flags in this fun quiz!",
    image:
      "https://res.cloudinary.com/dpb7crcko/image/upload/v1773779391/Flag_quiz_fbziua.png",
    tags: [
      "HTML",
      "CSS",
      "JavaScript",
      "Node.js",
      "Express.js",
      "PostgreSQL",
      "EJS (Embedded JavaScript)",
    ],
    category: "web",
    github: "https://github.com/Rahmaaaan/FlagsQuiz",
    webapp: " ",
  },
  // {
  //   id: 2,
  //   title: "",
  //   date: "",
  //   description:
  //     "",
  //   image:
  //     "",
  //   tags: [],
  //   category: "",
  //   github: "",
  //   webapp: "",
  //   member: [
  //     {
  //       name: "",
  //       img: "",
  //       linkedin: "",
  //       github: "",
  //     },
  //     {
  //       name: "U",
  //       img: "",
  //       linkedin: "",
  //       github: "",
  //     },
  //   ],
  // },
];

export const TimeLineData = [
  { year: 2020, text: "Started my journey" },
  { year: 2023, text: "Comnpleted my graduation" },
  { year: 2024, text: "Got a job as Network Engineer" },
  { year: 2026, text: "Comnpleted my post-graduation" },
];
